<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="1" />
<!-- Breadcrumb -->
<div class="mb-3">
  <div class="row align-items-center">
    <div class="col-12">
      <div class="breadcrumb-container">
        <template v-if="p_idAtencion !== 0">
          <router-link to="/atencion">Atenciones</router-link>
          &rsaquo;
          <router-link :to="'/atencionform/' + p_idAtencion">
            Atención {{ p_numero }}
          </router-link>
          &rsaquo;
          <a href="#" @click.prevent="volverVacunas">Vacunas</a>
          &rsaquo; Vacunas Aplicadas
        </template>
        <template v-else>
          <router-link to="/persona">Personas</router-link>
          &rsaquo;
          <a href="#" @click.prevent="volverVacunas">Vacunas</a>
          &rsaquo; Vacunas Aplicadas
        </template>
      </div>
    </div>
  </div>
</div>
<hr />
    <h3 class="mt-4 mb-3">Vacunas Aplicadas</h3>

    <DataTable
      :data="vacunasAplicadas"
      :columns="columnasVacuna"
      idField="idVacunaPers"
      :acciones="false"
      :mostrarBotonTodos="true"
      :mostrarBotonNuevo="false"
      :mostrarBotonExcel="true"
      mensajeVacio="No hay vacunas aplicadas."
      @refresh="cargarDatos"
    />

    <Footer />
  </div>
</template>

<script>
import Layout from "@/components/Layout.vue";
import Footer from "@/components/Footer.vue";
import DataTable from "@/components/DataTable.vue";
import api from "@/services/api";

export default {
  components: { Layout, Footer, DataTable },
  props: {
    p_idPersona:  { type: Number, required: true },
    p_idAtencion: { type: Number, required: true },
    p_numero:     { type: String, required: true },
    p_edad:       { type: Number, required: true },
  },  
  data() {
    return {
      vacunacionData: [],
      columnasVacuna: [
        { field: 'vacunaNombre', label: 'Vacuna' },
        { field: 'descripcion',  label: 'Descripción' },
        {
          field: 'fechaApli',
          label: 'Fecha de Aplicación',
          format: (val) => {
            if (!val) return '';
            const d     = new Date(val);
            const day   = String(d.getDate()).padStart(2, '0');
            const month = String(d.getMonth() + 1).padStart(2, '0');
            const year  = d.getFullYear();
            return `${day}-${month}-${year}`;
          },
        },
      ],
    };
  },
  computed: {
    vacunasAplicadas() {
      return this.vacunacionData.map(item => ({
        idVacunaPers: item.idVacunaPers,
        vacunaNombre: item.vacunaNombre,
        descripcion:  this.getDescripcion(item),
        fechaApli:    item.fechaApli,
      }));
    },
  },
  methods: {
  volverVacunas() {
    this.$router.push({
      name: 'Persona_VacunaPers',
      state: {
        pagina:         'A',
        idAtencion:     this.p_idAtencion,
        estadoAtencion: '',
        numero:         this.p_numero,
        idPersona:      this.p_idPersona,
        edad:           this.p_edad,
      }
    });
  },  
    async cargarDatos() {
      try {
        const response = await api.get(`/vwvacunaperss/idpersona/${this.p_idPersona}`);
        this.vacunacionData = response.data;
      } catch (error) {
        console.error('Error al obtener los datos:', error);
      }
    },
    getDescripcion(item) {
      let desc = item.observacion || '';
      if (item.vacunaProdNombre) desc += '; ' + item.vacunaProdNombre;
      if (item.lote)             desc += '; ' + item.lote;
      return desc;
    },
  },
  mounted() {
    this.$refs.layoutRef.toggleProcesos();
    this.$refs.layoutRef.toggleReportes();
    this.$refs.layoutRef.toggleParametros();
    this.$refs.layoutRef.toggleAyuda();
    this.cargarDatos();
  },
};
</script>